module.exports = __webpack_public_path__ + "static/Branded-Rock-Identity-b2a01fe7547e98e19c1b4c5212380e41.jpg";